function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  filter: "url(#flag-id_svg__filter0_d_719_5316)"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#flag-id_svg__clip0_719_5316)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M32.125 23H4V4.25h28.125V23z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M32.125 23H4v-9.375h28.125V23z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M32.125 13.625H4V4.25h28.125v9.375z",
  fill: "#D80027"
})));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "flag-id_svg__clip0_719_5316"
}, /*#__PURE__*/React.createElement("rect", {
  x: 32.125,
  y: 23,
  width: 28.125,
  height: 18.75,
  rx: 2,
  transform: "rotate(-180 32.125 23)",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("filter", {
  id: "flag-id_svg__filter0_d_719_5316",
  x: 0,
  y: 0.25,
  width: 36.125,
  height: 26.75,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  "in": "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_719_5316"
}), /*#__PURE__*/React.createElement("feBlend", {
  "in": "SourceGraphic",
  in2: "effect1_dropShadow_719_5316",
  result: "shape"
})));

function SvgFlagId(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 27,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default SvgFlagId;